// import { enableProdMode } from '@angular/core';
// import { AppModule } from './app/app.module';
// import { environment } from './environments/environment';
import { bootstrapApplication, Title } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app/app.routes';
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalInterceptorConfiguration, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration, MsalRedirectComponent } from '@azure/msal-angular';
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { environment } from './environments/environment';
import { HTTP_INTERCEPTORS,provideHttpClient,withInterceptors,withInterceptorsFromDi } from '@angular/common/http';
import config from 'devextreme/core/config';
import { licenseKey } from './app/devextreme-license';




// if (environment.production) {
//   enableProdMode();
// }
 
config({ licenseKey });

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;
const msalConfig = {
    auth: {
        clientId: environment.clientid,
        authority: environment.authority,
        redirectUri: environment.redirectUri,
        postLogoutRedirectUri: environment.postLogoutRedirectUri,
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage,
        storeAuthStateInCookie: isIE,
    }
};


export function MSALInstanceFactory(): IPublicClientApplication {
    return new PublicClientApplication(msalConfig);
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string>>();
    protectedResourceMap.set(environment.apiEndpoint, environment.scopes);
    protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);
    return {
        // Change this to Popup
        interactionType: InteractionType.Redirect,
        protectedResourceMap
    };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
        // Change this to Popup
        interactionType: InteractionType.Redirect,
        authRequest: {
            scopes: environment.scopes
        }
    };
}
/*
const msalConfig =  {
    auth: {
            clientId:environment.clientid , // This is the ONLY mandatory field that you need to supply.
            authority: environment.authority, // Defaults to "https://login.microsoftonline.com/common"
            redirectUri: environment.redirectUri,//'http://localhost:4200/', // Points to window.location.origin. You must register this URI on Azure portal/App Registration.
            postLogoutRedirectUri: environment.postLogoutRedirectUri,// 'http://localhost:4200/#/log-out', // Indicates the page to navigate after logout.
            navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
        },
  };*/

  const msalInstance = new PublicClientApplication(msalConfig);

const msalGuardConfig = {

  InteractionType:InteractionType.Redirect,
  authRequest: {
    scopes: ['user.read']
  }
};


bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(appRoutes),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory },
    { provide: MSAL_INTERCEPTOR_CONFIG, useFactory: MSALInterceptorConfigFactory },
    { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
    { provide: MSAL_GUARD_CONFIG, useFactory: MSALGuardConfigFactory },
    MsalService,
    MsalBroadcastService,
    MsalGuard,
    Title
  ]
}).catch(err => console.error(err));